import { render, staticRenderFns } from "./SearchStaffDialog.vue?vue&type=template&id=32d4da98&"
import script from "./SearchStaffDialog.vue?vue&type=script&lang=ts&"
export * from "./SearchStaffDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports